module.exports = __webpack_public_path__ + "static/media/CT_2019_30444_3901.c1f3a15e.png";